var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"d-flex h-100"},[_c('div',{staticClass:"justify-content-center align-self-center w-100"},[_c('MenuItem',{staticStyle:{"margin-top":"-100px"}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }